import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="19" height="23" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M9.5 2.867l7 3.11v4.7c0 4.52-2.98 8.69-7 9.93-4.02-1.24-7-5.41-7-9.93v-4.7l7-3.11zm0-2.19l-9 4v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12v-6l-9-4zm-1 6h2v2h-2v-2zm0 4h2v6h-2v-6z" fill="#444" /></svg>;